/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArchiveReleaseItems } from '../fn/release-notes/archive-release-items';
import { ArchiveReleaseItems$Params } from '../fn/release-notes/archive-release-items';
import { Get } from '../fn/release-notes/get';
import { Get$Params } from '../fn/release-notes/get';
import { List } from '../fn/release-notes/list';
import { List$Params } from '../fn/release-notes/list';
import { PrepareReleaseItems } from '../fn/release-notes/prepare-release-items';
import { PrepareReleaseItems$Params } from '../fn/release-notes/prepare-release-items';
import { ReleaseNotesViewModel } from '../models/release-notes-view-model';
import { ReleaseToProduction } from '../fn/release-notes/release-to-production';
import { ReleaseToProduction$Params } from '../fn/release-notes/release-to-production';

@Injectable({ providedIn: 'root' })
export class ReleaseNotesApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiReleaseNotesListGet()` */
  static readonly ApiReleaseNotesListGetPath = '/api/ReleaseNotes/List';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method doesn't expect any request body.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReleaseNotesViewModel>>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  List(params?: List$Params, context?: HttpContext): Observable<Array<ReleaseNotesViewModel>> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReleaseNotesViewModel>>): Array<ReleaseNotesViewModel> => r.body)
    );
  }

  /** Path part for operation `apiReleaseNotesGetPost()` */
  static readonly ApiReleaseNotesGetPostPath = '/api/ReleaseNotes/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ReleaseNotesViewModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<ReleaseNotesViewModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReleaseNotesViewModel>): ReleaseNotesViewModel => r.body)
    );
  }

  /** Path part for operation `apiReleaseNotesPrepareReleaseItemsPost()` */
  static readonly ApiReleaseNotesPrepareReleaseItemsPostPath = '/api/ReleaseNotes/PrepareReleaseItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `PrepareReleaseItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  PrepareReleaseItems$Response(params?: PrepareReleaseItems$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return PrepareReleaseItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `PrepareReleaseItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  PrepareReleaseItems(params?: PrepareReleaseItems$Params, context?: HttpContext): Observable<string> {
    return this.PrepareReleaseItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReleaseNotesReleaseToProductionPost()` */
  static readonly ApiReleaseNotesReleaseToProductionPostPath = '/api/ReleaseNotes/ReleaseToProduction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ReleaseToProduction()` instead.
   *
   * This method doesn't expect any request body.
   */
  ReleaseToProduction$Response(params?: ReleaseToProduction$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ReleaseToProduction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ReleaseToProduction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ReleaseToProduction(params?: ReleaseToProduction$Params, context?: HttpContext): Observable<string> {
    return this.ReleaseToProduction$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReleaseNotesArchiveReleaseItemsPost()` */
  static readonly ApiReleaseNotesArchiveReleaseItemsPostPath = '/api/ReleaseNotes/ArchiveReleaseItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ArchiveReleaseItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  ArchiveReleaseItems$Response(params?: ArchiveReleaseItems$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ArchiveReleaseItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ArchiveReleaseItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ArchiveReleaseItems(params?: ArchiveReleaseItems$Params, context?: HttpContext): Observable<string> {
    return this.ArchiveReleaseItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
